import React from 'react'
import { NumberPad } from '@/components'
import { useSellMoneyStore } from '@/store/useSellMoneyStore'

export const SellMoneyNumberPad: React.FC = () => {
  // Store state
  const isFiatMode = useSellMoneyStore((state) => state.isFiatMode)
  const fiatAmount = useSellMoneyStore((state) => state.fiatAmount)
  const cryptoAmount = useSellMoneyStore((state) => state.cryptoAmount)
  const setCryptoAmount = useSellMoneyStore((state) => state.setCryptoAmount)
  const setFiatAmount = useSellMoneyStore((state) => state.setFiatAmount)
  const fromCurrency = useSellMoneyStore((state) => state.fromCurrency)
  const shakeComponent = useSellMoneyStore((state) => state.shakeComponent)

  return (
    <NumberPad
      isFiatMode={isFiatMode}
      fiatAmount={fiatAmount}
      cryptoAmount={cryptoAmount}
      setFiatAmount={setFiatAmount}
      setCryptoAmount={setCryptoAmount}
      selectedCurrency={fromCurrency}
      shakeComponent={shakeComponent}
      maxLength={12}
    />
  )
}
